import { MetaFunction, useActionData } from "@remix-run/react";
import { ActionFunction, LoaderFunction, redirect } from "@remix-run/node";
import LoginForm from "app/components/Login";
import { loginAction } from "app/actions/login.action";
import { getAuthFromRequest } from "app/auth/auth";
import { SEOHandle } from "@nasa-gcn/remix-seo";
import { getSocialMetaTags } from "app/utils/meta";

export const meta: MetaFunction = () =>
  getSocialMetaTags({
    title: "Login | Promotional Products Now",
    description: "Welcome to Promotional Products Now",
    url: "https://www.promotionalproductsnow.au/login",

    extra: [
      { tagName: "link", rel: "canonical", href: "https://www.promotionalproductsnow.au/login" },
    ],
  });

interface ActionData {
  success: boolean;
  errors?: Record<string, string>;
  error?: string;
}

export const handle: SEOHandle = {
  getSitemapEntries: async () => [
    {
      route: "/login",
      priority: 0.6,
      lastmod: new Date().toISOString(),
      changefreq: "monthly",
    },
  ],
};

export const loader: LoaderFunction = async ({ request }) => {
  const user = await getAuthFromRequest(request);
  if (user) return redirect("/");
  return null;
};

export const action: ActionFunction = async ({ request }) => {
  return loginAction(request);
};

export default function Login(): JSX.Element {
  return (
    <div>
      <div className="py-4 md:py-8">
        <h1 className="text-2xl md:text-3xl xl:text-4xl 2xl:text-5xl 4xl:text-6xl font-bold text-dark text-center">
          Login to your account
        </h1>
        <p className="mt-4 text-lg font-semibold text-dark text-center">
          Enter your account details below
        </p>
        <div className="flex flex-col justify-center items-center px-6">
          <div className="md:px-2 py-6 w-full md:w-2/5">
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
}
